module.exports = __webpack_public_path__ + "static/img/icon-11.fec4ad32.png";